export function getTranslatedQuestionLabel(formEntry, language) {
    const translations = formEntry.field?.translations?.label;
    // the keys of translations would look something like this
    // ['fr-fr', 'fr-ca', 'en-gb', 'es-es', 'nl-nl', 'de-de', 'ca-es', 'it', 'pt-pt', 'br', 'eu', 'en-us', 'en-ca', 'ru-ru', 'el-gr', 'tr-tr'];
    // while the language from i18n is like this "fr-FR"
    if (translations) {
        // exact match, for example fr-FR to fr-fr
        if (translations?.[language?.toLowerCase()]) return translations?.[language?.toLowerCase()];
        // fallback, for example fr-BE to fr-fr or it-IT to it
        const keys = Object.keys(translations);
        const fallback = keys.find(key => key.toLowerCase().slice(0, 2) === language.toLowerCase().slice(0, 2));
        if (fallback) return translations[fallback];
    }
    // if all else fail, return the field name (usually english, unless it's a custom field)
    return formEntry.question;
}
